export const IS_DEV = process.env.NODE_ENV === 'development';
export const API_URL = process.env.API_URL || '/';
export const BASENAME = process.env.BASENAME || '';
export const XC_URL = process.env.XC_URL || 'https://experience.rb3ca-production.redbullaws.com';
const BASE_BUNDLE_URL = process.env.BASE_BUNDLE_URL || 'https://addons-bracketeditorandtournamenttrees.redbull.com';
export const BUNDLE_URL = `${BASE_BUNDLE_URL}/frontend/Bracket.js`;
